// Header data containing information for different languages
const headerData = {
  czech: {
    name: "ROBERT TICHÝ",
    title: "HOUSLAŘ",
    navLinks: ["ÚVOD", "HOUSLE", "VIOLA", "VIOLONCELLO", "VIOLA DA GAMBA"],
  },
  english: {
    name: "ROBERT TICHY",
    title: "VIOLIN MAKER",
    navLinks: ["HOME", "VIOLIN", "VIOLA", "CELLO", "VIOLA DA GAMBA"],
  },
  spanish: {
    name: "ROBERT TICHY",
    title: "FABRICANTE DE VIOLINES",
    navLinks: ["INICIO", "VIOLÍN", "VIOLA", "VIOLONCHELO", "VIOLA DA GAMBA"],
  },
  french: {
    name: "ROBERT TICHY",
    title: "FACTEUR DE VIOLON",
    navLinks: ["ACCUEIL", "VIOLON", "ALTO", "VIOLONCELLE", "VIOLE DE GAMBE"],
  },
};

export default headerData;
